import Claims from '../components/claims/Claims';
import ClaimsEdit from '../components/claims/ClaimsEdit';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/claims',
  component: Template,
  children: [
    {
      path: '',
      name: 'Claims',
      component: Claims,
      meta: {
        title: 'Claims - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'ClaimsEdit',
      component: ClaimsEdit,
      meta: {
        title: 'Edit Claim - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/claimsRoutes.js